import React, { useState } from "react";
import { Download, Filter } from "lucide-react";
function InvoiceAllocationDetail() {
  const [allocations] = useState([
    // INV-2026-245 - Acme Corporation - February 2026
    {
      id: 1,
      invoiceNumber: "INV-2026-245",
      client: "Acme Corporation",
      serviceMonth: "2026-02",
      invoiceLine: "Line 1: Pallet Storage",
      serviceCode: "PALLET_STORAGE",
      glCode: "41000",
      costCenter: "WH-01",
      productLine: "Warehouse",
      allocatedAmount: 3500,
      lineTotal: 3500,
      allocationPercent: 100
    },
    {
      id: 2,
      invoiceNumber: "INV-2026-245",
      client: "Acme Corporation",
      serviceMonth: "2026-02",
      invoiceLine: "Line 2: Labor Hours",
      serviceCode: "LABOR_HOURS",
      glCode: "42000",
      costCenter: "OPS-01",
      productLine: "Operations",
      allocatedAmount: 5200,
      lineTotal: 5200,
      allocationPercent: 100
    },
    {
      id: 3,
      invoiceNumber: "INV-2026-245",
      client: "Acme Corporation",
      serviceMonth: "2026-02",
      invoiceLine: "Line 3: Order Processing",
      serviceCode: "ORDER_PROCESSING",
      glCode: "43000",
      costCenter: "OPS-01",
      productLine: "Operations",
      allocatedAmount: 2100,
      lineTotal: 3e3,
      allocationPercent: 70
    },
    {
      id: 4,
      invoiceNumber: "INV-2026-245",
      client: "Acme Corporation",
      serviceMonth: "2026-02",
      invoiceLine: "Line 3: Order Processing",
      serviceCode: "ORDER_PROCESSING",
      glCode: "43500",
      costCenter: "IT-01",
      productLine: "Technology",
      allocatedAmount: 900,
      lineTotal: 3e3,
      allocationPercent: 30
    },
    {
      id: 5,
      invoiceNumber: "INV-2026-245",
      client: "Acme Corporation",
      serviceMonth: "2026-02",
      invoiceLine: "Line 4: Hosting Fee",
      serviceCode: "HOSTING_MONTHLY",
      glCode: "44000",
      costCenter: "IT-01",
      productLine: "Technology",
      allocatedAmount: 1300,
      lineTotal: 1300,
      allocationPercent: 100
    },
    // INV-2026-244 - Stellar Industries - February 2026
    {
      id: 6,
      invoiceNumber: "INV-2026-244",
      client: "Stellar Industries",
      serviceMonth: "2026-02",
      invoiceLine: "Line 1: Pallet Storage",
      serviceCode: "PALLET_STORAGE",
      glCode: "41000",
      costCenter: "WH-01",
      productLine: "Warehouse",
      allocatedAmount: 2800,
      lineTotal: 2800,
      allocationPercent: 100
    },
    {
      id: 7,
      invoiceNumber: "INV-2026-244",
      client: "Stellar Industries",
      serviceMonth: "2026-02",
      invoiceLine: "Line 2: Shipping Fee",
      serviceCode: "SHIPPING_FEE",
      glCode: "45000",
      costCenter: "LOG-01",
      productLine: "Logistics",
      allocatedAmount: 3600,
      lineTotal: 4500,
      allocationPercent: 80
    },
    {
      id: 8,
      invoiceNumber: "INV-2026-244",
      client: "Stellar Industries",
      serviceMonth: "2026-02",
      invoiceLine: "Line 2: Shipping Fee",
      serviceCode: "SHIPPING_FEE",
      glCode: "45500",
      costCenter: "WH-01",
      productLine: "Warehouse",
      allocatedAmount: 900,
      lineTotal: 4500,
      allocationPercent: 20
    },
    {
      id: 9,
      invoiceNumber: "INV-2026-244",
      client: "Stellar Industries",
      serviceMonth: "2026-02",
      invoiceLine: "Line 3: Labor Hours",
      serviceCode: "LABOR_HOURS",
      glCode: "42000",
      costCenter: "OPS-01",
      productLine: "Operations",
      allocatedAmount: 1850,
      lineTotal: 1850,
      allocationPercent: 100
    },
    // INV-2026-243 - Global Tech Inc - January 2026
    {
      id: 10,
      invoiceNumber: "INV-2026-243",
      client: "Global Tech Inc",
      serviceMonth: "2026-01",
      invoiceLine: "Line 1: Hosting Fee",
      serviceCode: "HOSTING_MONTHLY",
      glCode: "44000",
      costCenter: "IT-01",
      productLine: "Technology",
      allocatedAmount: 4200,
      lineTotal: 4200,
      allocationPercent: 100
    },
    {
      id: 11,
      invoiceNumber: "INV-2026-243",
      client: "Global Tech Inc",
      serviceMonth: "2026-01",
      invoiceLine: "Line 2: Order Processing",
      serviceCode: "ORDER_PROCESSING",
      glCode: "43000",
      costCenter: "OPS-01",
      productLine: "Operations",
      allocatedAmount: 7717.5,
      lineTotal: 11025,
      allocationPercent: 70
    },
    {
      id: 12,
      invoiceNumber: "INV-2026-243",
      client: "Global Tech Inc",
      serviceMonth: "2026-01",
      invoiceLine: "Line 2: Order Processing",
      serviceCode: "ORDER_PROCESSING",
      glCode: "43500",
      costCenter: "IT-01",
      productLine: "Technology",
      allocatedAmount: 3307.5,
      lineTotal: 11025,
      allocationPercent: 30
    }
  ]);
  const [filters, setFilters] = useState({
    client: "",
    invoiceNumber: "",
    serviceMonth: ""
  });
  const filteredAllocations = allocations.filter((allocation) => {
    const matchesClient = !filters.client || allocation.client.toLowerCase().includes(filters.client.toLowerCase());
    const matchesInvoice = !filters.invoiceNumber || allocation.invoiceNumber.toLowerCase().includes(filters.invoiceNumber.toLowerCase());
    const matchesMonth = !filters.serviceMonth || allocation.serviceMonth === filters.serviceMonth;
    return matchesClient && matchesInvoice && matchesMonth;
  });
  const groupedAllocations = filteredAllocations.reduce((acc, allocation) => {
    const key = `${allocation.invoiceNumber}-${allocation.invoiceLine}`;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(allocation);
    return acc;
  }, {});
  const departmentTotals = filteredAllocations.reduce((acc, allocation) => {
    if (!acc[allocation.productLine]) {
      acc[allocation.productLine] = 0;
    }
    acc[allocation.productLine] += allocation.allocatedAmount;
    return acc;
  }, {});
  const grandTotal = filteredAllocations.reduce((sum, allocation) => sum + allocation.allocatedAmount, 0);
  const uniqueClients = Array.from(new Set(allocations.map((a) => a.client))).sort();
  const uniqueInvoices = Array.from(new Set(allocations.map((a) => a.invoiceNumber))).sort();
  const uniqueMonths = Array.from(new Set(allocations.map((a) => a.serviceMonth))).sort().reverse();
  return <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Invoice Allocation Detail
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Review internal revenue allocations for P&L validation
        </p>
      </div>

      {
    /* Filters */
  }
      <div className="mb-6 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <Filter className="w-5 h-5 text-gray-600 dark:text-gray-400" />
          <h2 className="text-lg font-medium text-gray-900 dark:text-gray-100">Filters</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Client
            </label>
            <select
    value={filters.client}
    onChange={(e) => setFilters({ ...filters, client: e.target.value })}
    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  >
              <option value="">All Clients</option>
              {uniqueClients.map((client) => <option key={client} value={client}>{client}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Invoice Number
            </label>
            <select
    value={filters.invoiceNumber}
    onChange={(e) => setFilters({ ...filters, invoiceNumber: e.target.value })}
    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  >
              <option value="">All Invoices</option>
              {uniqueInvoices.map((invoice) => <option key={invoice} value={invoice}>{invoice}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Service Month
            </label>
            <select
    value={filters.serviceMonth}
    onChange={(e) => setFilters({ ...filters, serviceMonth: e.target.value })}
    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  >
              <option value="">All Months</option>
              {uniqueMonths.map((month) => <option key={month} value={month}>
                  {(/* @__PURE__ */ new Date(month + "-01")).toLocaleDateString("en-US", { year: "numeric", month: "long" })}
                </option>)}
            </select>
          </div>
        </div>
        <div className="mt-4 flex gap-3">
          <button
    onClick={() => setFilters({ client: "", invoiceNumber: "", serviceMonth: "" })}
    className="app-btn-gloss"
  >
            Clear Filters
          </button>
          <button className="app-btn-gloss">
            <Download className="w-4 h-4" />
            Export to Excel
          </button>
        </div>
      </div>

      {
    /* Allocation Detail Table */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Invoice Line
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Service Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  GL Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Cost Center
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Product Line
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Allocated Amount
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
              {Object.entries(groupedAllocations).map(([key, lineAllocations]) => {
    const isSplit = lineAllocations.length > 1;
    const firstAllocation = lineAllocations[0];
    return <React.Fragment key={key}>
                    {
      /* Invoice/Client header row */
    }
                    <tr className="bg-gray-100 dark:bg-gray-800">
                      <td colSpan={6} className="px-6 py-3 text-sm font-medium text-gray-900 dark:text-gray-100">
                        <div className="flex items-center justify-between">
                          <span>
                            {firstAllocation.invoiceNumber} - {firstAllocation.client} - {(/* @__PURE__ */ new Date(firstAllocation.serviceMonth + "-01")).toLocaleDateString("en-US", { year: "numeric", month: "long" })}
                          </span>
                          {isSplit && <span className="px-2 py-0.5 bg-blue-600 text-white text-xs rounded">
                              Split Allocation
                            </span>}
                        </div>
                      </td>
                    </tr>
                    {
      /* Allocation detail rows */
    }
                    {lineAllocations.map((allocation, index) => <tr
      key={allocation.id}
      className={`hover:bg-gray-50 dark:hover:bg-gray-800 ${isSplit ? "bg-blue-50 dark:bg-blue-950" : ""}`}
    >
                        <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                          {index === 0 && allocation.invoiceLine}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                          {allocation.serviceCode}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                          {allocation.glCode}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                          {allocation.costCenter}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                          {allocation.productLine}
                        </td>
                        <td className="px-6 py-4 text-sm text-right">
                          <div className="flex flex-col items-end">
                            <span className="font-medium text-gray-900 dark:text-gray-100">
                              ${allocation.allocatedAmount.toFixed(2)}
                            </span>
                            {isSplit && <span className="text-xs text-gray-600 dark:text-gray-400">
                                {allocation.allocationPercent}% of ${allocation.lineTotal.toFixed(2)}
                              </span>}
                          </div>
                        </td>
                      </tr>)}
                  </React.Fragment>;
  })}
            </tbody>
            <tfoot className="bg-gray-50 dark:bg-gray-800 font-semibold">
              <tr>
                <td colSpan={5} className="px-6 py-4 text-sm text-right text-gray-900 dark:text-gray-100">
                  Grand Total:
                </td>
                <td className="px-6 py-4 text-sm text-right text-gray-900 dark:text-gray-100">
                  ${grandTotal.toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {
    /* Department Summary */
  }
      <div className="mt-6 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm p-6">
        <h2 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4">
          Allocation Summary by Product Line
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {Object.entries(departmentTotals).sort((a, b) => b[1] - a[1]).map(([productLine, total]) => <div key={productLine} className="border border-gray-200 dark:border-gray-700 rounded p-4">
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">{productLine}</p>
                <p className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                  ${total.toFixed(2)}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                  {(total / grandTotal * 100).toFixed(1)}% of total
                </p>
              </div>)}
        </div>
      </div>

      {
    /* Legend */
  }
      <div className="mt-4 flex items-center gap-6 text-sm text-gray-600 dark:text-gray-400">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded" />
          <span>Split Allocation</span>
        </div>
        <div className="text-gray-900 dark:text-gray-100 font-medium">
          Total Allocations: {filteredAllocations.length} lines
        </div>
      </div>
    </div>;
}
export {
  InvoiceAllocationDetail
};
